import React from 'react';
import AddEdit from '../../components/category/add_edit/Component';

const Component = () => {
  return (
      <AddEdit componentTitle="Category"/>
  )
}

export default Component
